/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Open_New_Window_ActiveInputs */



/**
* | output |
* | --- |
* | "Open in the separate window" |
*
* @param {Artifact_Open_New_Window_ActiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_open_new_window_active = /** @type {((inputs?: Artifact_Open_New_Window_ActiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Open_New_Window_ActiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zum separaten Fenster wechseln")
	return /** @type {LocalizedString} */ ("Open in the separate window")
});